import { AppBar, Box, Toolbar, Typography } from '@mui/material'
import logo from '../assets/logo.png'
import { AccountCircle } from '@mui/icons-material'

export default function TopBar() {
  // 👉 ดึงค่าจาก localStorage
  const username = localStorage.getItem("username") || "ผู้ใช้งาน"
  const roleName = localStorage.getItem("roleName") || ""

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        background: 'linear-gradient(90deg, #FFF 0%, #FEDC00 100%)',
        color: "#000",
      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        {/* โลโก้ */}
        <Box
          component="img"
          src={logo}
          alt="logo"
          sx={{ height: 50 }}
        />

        {/* ชื่อผู้ใช้ + Role */}
        <Box display="flex" alignItems="center" gap={1}>
          <AccountCircle fontSize="large" />
          <Typography variant="body1" fontWeight='bold' color="text.secondary">
            {roleName}
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  )
}
